import { defineConfigFragment } from "@nexus/widget-sdk";

/**
 * Settings shared by several widgets, as versioned fragments a widget's
 * settings extend (`defineWidgetSettings({ extends: [...] })`).
 *
 * A fragment is a contract between the widgets using it and the dashboards
 * storing its keys: rewording a title is fine, changing a key, a type or a
 * default is a new version (a new fragment beside this one).
 */

/** A chart that draws itself in (`useChartAnimation`); off by default, drawn at once. */
export const ANIMATE_CHART_CONFIG = defineConfigFragment("nexus-kit:animate-chart", 1, {
  animateChart: {
    type: "boolean",
    title: "Animate chart",
    description: "The chart draws itself in when it loads. Off: drawn at once",
    default: false,
    "x-ui": { category: "display", group: "motion", order: 81 },
  },
});

/** Figures that count up to their value (`useAnimatedNumber`); off by default. */
export const ANIMATE_VALUE_CONFIG = defineConfigFragment("nexus-kit:animate-value", 1, {
  animateValue: {
    type: "boolean",
    title: "Animate value",
    default: false,
    "x-ui": { category: "display", group: "motion", order: 80 },
  },
});

/** How a time chart shows the part of its period without data (see `missingDataMode`). */
export const MISSING_DATA_CONFIG = defineConfigFragment("nexus-kit:missing-data", 1, {
  missingData: {
    type: "string",
    title: "Missing data",
    default: "gap",
    oneOf: [
      { const: "gap", title: "Show gap" },
      { const: "fit", title: "Fit to data" },
    ],
    "x-ui": { category: "display", order: 70 },
  },
});

/** An optional band of headline figures above a chart; hidden by default. */
export const SUMMARY_BAND_CONFIG = defineConfigFragment("nexus-kit:summary-band", 1, {
  summary: {
    type: "string",
    title: "Summary",
    default: "hidden",
    oneOf: [
      { const: "shown", title: "Shown" },
      { const: "hidden", title: "Hidden" },
    ],
    "x-ui": { category: "display", order: 20 },
  },
});
